import api from './api';

/**
 * Request password reset email
 * @param {string} email - User email
 * @returns {Promise<{success: boolean, message?: string, error?: string}>}
 */
export const forgotPassword = async (email) => {
  try {
    const response = await api.post('/auth/forgot-password', { email });
    return {
      success: response.data.success,
      message: response.data.message
    };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.error || 'Failed to send reset email'
    };
  }
};

/**
 * Reset password with token
 * @param {string} token - Reset token from email
 * @param {string} password - New password
 * @returns {Promise<{success: boolean, message?: string, error?: string}>}
 */
export const resetPassword = async (token, password) => {
  try {
    const response = await api.post('/auth/reset-password', { token, password });
    return {
      success: response.data.success,
      message: response.data.message
    };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.error || 'Failed to reset password'
    };
  }
};

/**
 * Verify email with token
 * @param {string} token - Verification token from email
 * @returns {Promise<{success: boolean, user?: object, message?: string, error?: string}>}
 */
export const verifyEmail = async (token) => {
  try {
    const response = await api.get(`/auth/verify-email/${token}`);
    return {
      success: response.data.success,
      user: response.data.data?.user,
      message: response.data.message
    };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.error || 'Failed to verify email'
    };
  }
};

/**
 * Resend verification email (requires auth)
 * @returns {Promise<{success: boolean, message?: string, error?: string}>}
 */
export const resendVerification = async () => {
  try {
    const response = await api.post('/auth/resend-verification');
    return {
      success: response.data.success,
      message: response.data.message
    };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.error || 'Failed to resend verification email'
    };
  }
};
